import {deepClone} from "@/utils/index";
import Vue from "vue";
import {timeStampToDate, numberFormat} from "@/utils/index";
import {refresh} from './refresh'
import {persistentData} from './persistentData'

/**
 * 中间页store  用于多页面间沟通
 */
export const middleware = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    refresh: refresh,
    persistentData: persistentData,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/middleware/middleware.js